var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.2904 5.99219H0","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M9.75 1L15.2911 5.99224L9.75 10.9583","strokeMiterlimit":"10","key":1})]);
}

Arrow.defaultProps = {"width":"17","height":"12","viewBox":"0 0 17 12","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
